import { getAuth, connectAuthEmulator } from "firebase/auth";
import { app } from "./config.js";

export const auth = getAuth(app);

if (typeof import.meta !== "undefined" && import.meta.env?.VITE_USE_EMULATOR === "true") {
  const port = Number(import.meta.env?.VITE_EMULATOR_AUTH_PORT || 9099);
  try {
    connectAuthEmulator(auth, `http://127.0.0.1:${port}`, { disableWarnings: true });
    console.log(`[Auth] Connected to local emulator on http://127.0.0.1:${port}`);
  } catch (err) {
    console.warn("[Auth] Emulator notice:", err.message);
  }
}

export default auth;
